"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDmsTokenRefresh = void 0;
var _react = require("react");
var _DmsFetch = require("../components/DmsFetch/DmsFetch");
var _DmsTokenHook = require("../components/DmsTokenHook/DmsTokenHook");
var _HttpStatus = require("../constants/HttpStatus");
var _userInteractionToken = require("../functions/userInteractionToken");
const TOKEN_REFRESH_ADVANCE_MS = 10 * 1000;
const getTokenExpiryMs = accessToken => {
  try {
    const payloadBase64 = accessToken.split('.')[1];
    const normalizedPayload = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(normalizedPayload));
    return payload.exp ? payload.exp * 1000 : null;
  } catch (_unused) {
    return null;
  }
};
const getRefreshDelay = accessToken => {
  const expiryMs = accessToken ? getTokenExpiryMs(accessToken) : null;
  if (!expiryMs) {
    return TOKEN_REFRESH_ADVANCE_MS;
  }
  return Math.max(expiryMs - Date.now() - TOKEN_REFRESH_ADVANCE_MS, 0);
};
const useDmsTokenRefresh = function () {
  let {
    dummyURL = '/info',
    dummyMethod = 'GET',
    refreshTokenURL = '/refresh_token'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const refreshTokenProcess = (0, _react.useRef)(null);
  const scheduleNextRefresh = () => {
    const tokenData = (0, _DmsTokenHook.getToken)();
    if (!(tokenData !== null && tokenData !== void 0 && tokenData.access_token)) {
      clearTimeout(refreshTokenProcess.current);
      return;
    }
    clearTimeout(refreshTokenProcess.current);
    refreshTokenProcess.current = setTimeout(refreshTokenFn, getRefreshDelay(tokenData.access_token));
  };
  const refreshTokenFn = async () => {
    const refreshData = (0, _DmsTokenHook.getRefreshToken)();
    const tokenData = (0, _DmsTokenHook.getToken)();
    if (!refreshData || !tokenData) {
      clearTimeout(refreshTokenProcess.current);
      return null;
    }
    if (refreshData.tokenUses != null && refreshData.tokenUses > 0) {
      const payload = {
        access_token: tokenData.access_token,
        refresh_token: refreshData.refreshToken
      };
      const res = await (0, _DmsFetch.fetchUrl)(refreshTokenURL, 'POST', true, payload);
      if ((res === null || res === void 0 ? void 0 : res.status) === _HttpStatus.HTTP_STATUS.OK_200) {
        (0, _DmsTokenHook.setToken)(res.data);
        (0, _userInteractionToken.userInteractionToken)(true);
      }
    } else {
      await (0, _DmsFetch.fetchDataIgnoringTokenUsage)(dummyURL, dummyMethod, true);
    }
    scheduleNextRefresh();
  };
  (0, _react.useEffect)(() => {
    scheduleNextRefresh();
    return () => {
      clearTimeout(refreshTokenProcess.current);
    };
  }, []);
  return null;
};
exports.useDmsTokenRefresh = useDmsTokenRefresh;